import * as React from 'react';
import styles from '../components/Skills.module.css'
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import MobileStepper from '@mui/material/MobileStepper';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';

const steps = [
  {
    description: '| Analytical Thinking | Problem-Solving Abilities | Self-Motivated | Strong Communication | Collaboration & Teamwork |',
  },
  {
    description:'| Project Management | Planning | Time Management | Adaptability | Continuous Learning |',
  },
  {
    description: '| Coaching Mindset | Resilience | Curiosity | Emotional Intelligence | Creativity |',
  },
];

export default function Courousel() {
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = steps.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <div className={styles.courousel}>
        <Box sx={{ maxWidth: 450, flexGrow: 1}} >
      <Box sx={{ height: 290, maxWidth: 450, width: '100%', p: 5}}>
        {steps[activeStep].description}
        <MobileStepper 
        variant="text"
        steps={maxSteps}
        position="static"
        activeStep={activeStep}
        nextButton={
          <Button
            size="large"
            onClick={handleNext}
            disabled={activeStep === maxSteps - 1}
          >
            
            {theme.direction === 'rtl' ? (
              <KeyboardArrowLeft />
            ) : (
              <KeyboardArrowRight />
            )}
          </Button>
        }
        backButton={
          <Button size="large" onClick={handleBack} disabled={activeStep === 0}>
            {theme.direction === 'rtl' ? (
              <KeyboardArrowRight />
            ) : (
              <KeyboardArrowLeft />
            )}
            
          </Button>
        }
        sx={{ fontSize:12, color:'gray', alignItems:'center', mt:2}}
      />
      </Box>
     
    </Box>
    </div>
    
  );
}